const Pagination = {
  pageSizes: [10, 20, 30, 40, 50, 100]
}

export { Pagination };
